import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  AnalyticsLoggerService,
  GENERAL_EVENTS,
} from 'src/app/services/analytics-logger.service';
import { StripeService } from 'src/app/services/stripe.service';
import { AddComponent } from 'src/components/add/add.component';
import { AuthService } from 'src/services/auth/auth.service';

@Component({
  selector: 'settings-for-prefund-pro-thank-you',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './settings-for-prefund-pro-thank-you.component.html',
  styleUrl: './settings-for-prefund-pro-thank-you.component.scss',
})
export class SettingsForPrefundProThankYouComponent implements OnInit {
  isLoading = false;

  constructor(
    public stripeService: StripeService,
    private matSnackBar: MatSnackBar,
    private logger: AnalyticsLoggerService
  ) {}

  ngOnInit(): void {
    this.logger.logEvent(GENERAL_EVENTS.userSubscribed);
  }

  redirect() {
    try {
      this.isLoading = true;
      this.stripeService.redirectToCustomerPortal();
    } catch (e) {
      this.matSnackBar.open(JSON.stringify(e));
      this.isLoading = false;
    }
  }
}
